export default {
  lookups: {},
  lookupsZeus: {},
  groups: [],
  timeZones: [],
  insuranceCompanies: []
}



// WEBPACK FOOTER //
// ./src/store/modules/lookups/state.js